/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AcceptPolicyRequest,
  ApiUserTasksGetLastSelectedIdParameter,
  ApiUserTasksGetPageParameter,
  CreatePolicyRequest,
  GetPolicyResponse,
  PaginatedResultOfGetPolicyResponse,
  ProblemDetails,
  Result,
  ResultOfCreatePolicyResponse,
  SearchQueryRequest,
  UpdatePolicyRequest,
} from '../models/index';
import {
    AcceptPolicyRequestFromJSON,
    AcceptPolicyRequestToJSON,
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterToJSON,
    CreatePolicyRequestFromJSON,
    CreatePolicyRequestToJSON,
    GetPolicyResponseFromJSON,
    GetPolicyResponseToJSON,
    PaginatedResultOfGetPolicyResponseFromJSON,
    PaginatedResultOfGetPolicyResponseToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    ResultFromJSON,
    ResultToJSON,
    ResultOfCreatePolicyResponseFromJSON,
    ResultOfCreatePolicyResponseToJSON,
    SearchQueryRequestFromJSON,
    SearchQueryRequestToJSON,
    UpdatePolicyRequestFromJSON,
    UpdatePolicyRequestToJSON,
} from '../models/index';

export interface ApiPoliciesGetRequest {
    key?: string;
    xTenantID?: number;
}

export interface ApiPoliciesIdAcceptPostRequest {
    id: number;
    acceptPolicyRequest: AcceptPolicyRequest;
    xTenantID?: number;
}

export interface ApiPoliciesIdDeleteRequest {
    id: number;
    xTenantID?: number;
}

export interface ApiPoliciesPostRequest {
    createPolicyRequest: CreatePolicyRequest;
    xTenantID?: number;
}

export interface ApiPoliciesPutRequest {
    updatePolicyRequest: UpdatePolicyRequest;
    xTenantID?: number;
}

export interface ApiPoliciesScrollGetRequest {
    page?: ApiUserTasksGetPageParameter;
    pageSize?: ApiUserTasksGetPageParameter;
    lastSelectedId?: ApiUserTasksGetLastSelectedIdParameter;
    active?: boolean;
    xTenantID?: number;
}

export interface ApiPoliciesSearchPostRequest {
    page?: ApiUserTasksGetPageParameter;
    pageSize?: ApiUserTasksGetPageParameter;
    lastSelectedId?: ApiUserTasksGetLastSelectedIdParameter;
    active?: boolean;
    xTenantID?: number;
    searchQueryRequest?: SearchQueryRequest;
}

export interface ApiPoliciesUserIdGetRequest {
    id: number;
    page?: ApiUserTasksGetPageParameter;
    pageSize?: ApiUserTasksGetPageParameter;
    lastSelectedId?: ApiUserTasksGetLastSelectedIdParameter;
    active?: boolean;
    xTenantID?: number;
}

export interface GetPolicyByIdRequest {
    id: number;
    xTenantID?: number;
}

/**
 * 
 */
export class WaiversPoliciesApi extends runtime.BaseAPI {

    /**
     * Get policy by Key
     */
    async apiPoliciesGetRaw(requestParameters: ApiPoliciesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPolicyResponse>> {
        const queryParameters: any = {};

        if (requestParameters['key'] != null) {
            queryParameters['key'] = requestParameters['key'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/policies`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPolicyResponseFromJSON(jsonValue));
    }

    /**
     * Get policy by Key
     */
    async apiPoliciesGet(requestParameters: ApiPoliciesGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPolicyResponse> {
        const response = await this.apiPoliciesGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Accept policy
     */
    async apiPoliciesIdAcceptPostRaw(requestParameters: ApiPoliciesIdAcceptPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiPoliciesIdAcceptPost().'
            );
        }

        if (requestParameters['acceptPolicyRequest'] == null) {
            throw new runtime.RequiredError(
                'acceptPolicyRequest',
                'Required parameter "acceptPolicyRequest" was null or undefined when calling apiPoliciesIdAcceptPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/policies/{id}/accept`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AcceptPolicyRequestToJSON(requestParameters['acceptPolicyRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Accept policy
     */
    async apiPoliciesIdAcceptPost(requestParameters: ApiPoliciesIdAcceptPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiPoliciesIdAcceptPostRaw(requestParameters, initOverrides);
    }

    /**
     * Delete policy
     */
    async apiPoliciesIdDeleteRaw(requestParameters: ApiPoliciesIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiPoliciesIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/policies/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete policy
     */
    async apiPoliciesIdDelete(requestParameters: ApiPoliciesIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiPoliciesIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Create policy
     */
    async apiPoliciesPostRaw(requestParameters: ApiPoliciesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfCreatePolicyResponse>> {
        if (requestParameters['createPolicyRequest'] == null) {
            throw new runtime.RequiredError(
                'createPolicyRequest',
                'Required parameter "createPolicyRequest" was null or undefined when calling apiPoliciesPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/policies`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreatePolicyRequestToJSON(requestParameters['createPolicyRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfCreatePolicyResponseFromJSON(jsonValue));
    }

    /**
     * Create policy
     */
    async apiPoliciesPost(requestParameters: ApiPoliciesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfCreatePolicyResponse> {
        const response = await this.apiPoliciesPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update policy
     */
    async apiPoliciesPutRaw(requestParameters: ApiPoliciesPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['updatePolicyRequest'] == null) {
            throw new runtime.RequiredError(
                'updatePolicyRequest',
                'Required parameter "updatePolicyRequest" was null or undefined when calling apiPoliciesPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/policies`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdatePolicyRequestToJSON(requestParameters['updatePolicyRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update policy
     */
    async apiPoliciesPut(requestParameters: ApiPoliciesPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiPoliciesPutRaw(requestParameters, initOverrides);
    }

    /**
     * Get all policies
     */
    async apiPoliciesScrollGetRaw(requestParameters: ApiPoliciesScrollGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedResultOfGetPolicyResponse>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['lastSelectedId'] != null) {
            queryParameters['lastSelectedId'] = requestParameters['lastSelectedId'];
        }

        if (requestParameters['active'] != null) {
            queryParameters['active'] = requestParameters['active'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/policies/scroll`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedResultOfGetPolicyResponseFromJSON(jsonValue));
    }

    /**
     * Get all policies
     */
    async apiPoliciesScrollGet(requestParameters: ApiPoliciesScrollGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedResultOfGetPolicyResponse> {
        const response = await this.apiPoliciesScrollGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search policies
     */
    async apiPoliciesSearchPostRaw(requestParameters: ApiPoliciesSearchPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedResultOfGetPolicyResponse>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['lastSelectedId'] != null) {
            queryParameters['lastSelectedId'] = requestParameters['lastSelectedId'];
        }

        if (requestParameters['active'] != null) {
            queryParameters['active'] = requestParameters['active'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/policies/search`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchQueryRequestToJSON(requestParameters['searchQueryRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedResultOfGetPolicyResponseFromJSON(jsonValue));
    }

    /**
     * Search policies
     */
    async apiPoliciesSearchPost(requestParameters: ApiPoliciesSearchPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedResultOfGetPolicyResponse> {
        const response = await this.apiPoliciesSearchPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get policies by User
     */
    async apiPoliciesUserIdGetRaw(requestParameters: ApiPoliciesUserIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedResultOfGetPolicyResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiPoliciesUserIdGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['lastSelectedId'] != null) {
            queryParameters['lastSelectedId'] = requestParameters['lastSelectedId'];
        }

        if (requestParameters['active'] != null) {
            queryParameters['active'] = requestParameters['active'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/policies/user/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedResultOfGetPolicyResponseFromJSON(jsonValue));
    }

    /**
     * Get policies by User
     */
    async apiPoliciesUserIdGet(requestParameters: ApiPoliciesUserIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedResultOfGetPolicyResponse> {
        const response = await this.apiPoliciesUserIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get policy by ID
     */
    async getPolicyByIdRaw(requestParameters: GetPolicyByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPolicyResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getPolicyById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/policies/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPolicyResponseFromJSON(jsonValue));
    }

    /**
     * Get policy by ID
     */
    async getPolicyById(requestParameters: GetPolicyByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPolicyResponse> {
        const response = await this.getPolicyByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
